import { atom } from 'recoil';

export type FcmConciergeType = {
  date: string;
  clientUserId: number;
};

export type InterphoneType = {
  type: string | null;
  interphone_call_manage_id: number | null;
  room_name: number | null;
  status: number; // 0: 통화상태 아님, 1: 송신자 대기중, 2: 수신자 대기중, 3: 통화중, 4: 통화 불가 상태, 5: 접속 대기(RECCEIVER_ACCEPT)
  reject_reason?: string;
};

export const MESSAGE_TYPE_SALES = 'SALES';
export const MESSAGE_TYPE_CONCIERGE = 'CONCIERGE';
export const MESSAGE_TYPE_INTERPHONE = 'INTERPHONE';

export const fcmSalesState = atom<string>({
  key: 'fcmSalesState',
  default: '',
});

export const fcmSalesCountState = atom<number>({
  key: 'fcmSalesCountState',
  default: 0,
});

export const fcmConciergeState = atom<FcmConciergeType>({
  key: 'fcmConciergeState',
  default: {
    date: '',
    clientUserId: 0,
  },
});

export const fcmConciergeCountState = atom<number>({
  key: 'fcmConciergeCountState',
  default: 0,
});

export const fcmInterphoneState = atom<InterphoneType>({
  key: 'interphoneState',
  default: {
    type: null,
    interphone_call_manage_id: null,
    room_name: null,
    status: 0,
  },
});
